/**
 * Core Vendor Index
 */
import * as foundation from './foundation';
import * as vue from './vue';
export default {
    foundation,
    vue
};




// WEBPACK FOOTER //
// ./project/client/src/core/vendor/index.js